<script setup>
import { useField } from 'vee-validate';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: '',
  },
  autofocus: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    required: false,
    default: 'text',
  },
  id: {
    type: String,
    required: false,
    default: '',
  },
  autocomplete: {
    type: String,
    required: false,
    default: '',
  },
  as: {
    type: String,
    default: 'input',
  },
  value: {
    type: String,
    default: null,
  },
  validateOnInput: {
    type: Boolean,
    default: true,
  },
  validateOnBlur: {
    type: Boolean,
    default: true,
  },
  validateOnChange: {
    type: Boolean,
    default: true,
  },
  validateOnModelUpdate: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const atomInput = ref(null);

onMounted(() => {
  if (props.autofocus) {
    atomInput.value.focus();
  }
});

const { value: field } = useField(props.name, undefined, {
  initialValue: props.value,
  syncVModel: true,
  validateOnInput: props.validateOnInput,
  validateOnBlur: props.validateOnBlur,
  validateOnChange: props.validateOnChange,
  validateOnModelUpdate: props.validateOnModelUpdate,
});
</script>

<template>
  <input
    :id="id"
    ref="atomInput"
    v-model="field"
    :type="type"
    :name="name"
    :autocomplete="autocomplete"
    :placeholder="placeholder"
    :as="as"
    :disabled="disabled"
    :class="{ 'cursor-not-allowed': disabled }"
  />
</template>
